import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6420110d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = { class: "card-header-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_DynamicFormInJson = _resolveComponent("DynamicFormInJson")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jsonList, (item, jdx) => {
      return (_openBlock(), _createBlock(_component_el_card, { key: jdx }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", null, _toDisplayString(_ctx.title + (jdx + 1)), 1)
          ]),
          _createElementVNode("div", _hoisted_2, [
            (_ctx.canEdit)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "danger",
                  size: "mini",
                  onClick: ($event: any) => (_ctx.handleDeleteChildClick(jdx, item))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除")
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        default: _withCtx(() => [
          (item.show)
            ? (_openBlock(), _createBlock(_component_DynamicFormInJson, {
                key: 0,
                ref_for: true,
                ref: 'jsonFormRef' + jdx,
                index: jdx,
                model: item,
                "can-edit": _ctx.canEdit,
                "label-width": _ctx.labelWidth,
                rows: _ctx.rows,
                "role-ids": _ctx.roleIds,
                "col-span": _ctx.colSpan,
                "onUpdate:model": _ctx.handleChildFormUpdate
              }, null, 8, ["index", "model", "can-edit", "label-width", "rows", "role-ids", "col-span", "onUpdate:model"]))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1024))
    }), 128)),
    (_ctx.canEdit)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: _ctx.addData
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString('添加' + _ctx.title), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}